/** @format */

import useModal from '@/components/shared/Modal';
import ModalDialog from '@/components/shared/Modal/partials/Dialog';
import { selectorBookingCommercialConditions } from '@/ducks/bookingNew/selectors';
import { GTMVisitOtherRoomsv2 } from '@/ducks/googleTagManager/helpers/google-tag-manager';
import { Tenant, TRoom } from '@/ducks/room/declarations';
import { useAppSelector } from '@/redux/hooks';
import { caseUnsensitiveEquals } from '@/utils/helpers/caseUnsensitiveEquals';
import { utilityGetPrice } from '@/utils/helpers/utilityGetPrice';
import { useIntl } from 'gatsby-plugin-intl';
import React, { FC, useMemo, useState } from 'react';
import { CustomTitle } from '../../index.style';
import { ColiverBox } from './ColiverBox/ColiverBox';
import { RoomBox } from './RoomBox/RoomBox';
import { Colivers, ShowMoreButton } from './RoomColiversInfo.style';

const RoomColiversInfo: FC<RoomColiversInfoProps> = ({ room, rooms }) => {
  const commercialConditions = useAppSelector(selectorBookingCommercialConditions);
  const { formatMessage } = useIntl();
  const { Modal } = useModal();
  const [modalOpen, setModalOpen] = useState(false);
  const { getFormattedPrice } = useMemo(
    () => utilityGetPrice({ commercialConditions, room }),
    [commercialConditions, room],
  );
  const actualColiversFreeRoom: Tenant[] = useMemo(() => {
    return rooms.filter(room => room.type === 'coliver' || room.type === 'room');
  }, [rooms]);
  const handleGTMVisitOtherRoomsv2 = (id?: string) => {
    GTMVisitOtherRoomsv2(id ? id : 'show_all', room.code, getFormattedPrice());
  };
  const handleShowMore = () => {
    setModalOpen(true);
    handleGTMVisitOtherRoomsv2();
  };
  return (
    <>
      <CustomTitle $subtitle>{formatMessage({ id: 'pdp.who_you_will_find' })}</CustomTitle>
      <Colivers>{renderRoomList(actualColiversFreeRoom.slice(0, 6), getFormattedPrice(), room.code)}</Colivers>
      {actualColiversFreeRoom && actualColiversFreeRoom.length > 6 && (
        <ShowMoreButton onClick={handleShowMore}>{formatMessage({ id: 'pdp.show_all' })}</ShowMoreButton>
      )}
      <Modal isShow={modalOpen} opacity={0.5} onClose={() => setModalOpen(false)}>
        <ModalDialog title="pdp.who_you_will_find" setModalOpen={setModalOpen}>
          <Colivers>{renderRoomList(actualColiversFreeRoom, getFormattedPrice(), room.code)}</Colivers>
        </ModalDialog>
      </Modal>
    </>
  );
};

export default RoomColiversInfo;

const renderRoomList = (roomList: Tenant[], price: number, thisRoomCode: string) => {
  return roomList.map(room => {
    const isThisRoom = caseUnsensitiveEquals(room.bedCode, thisRoomCode);
    if (room.type === 'room')
      return <RoomBox key={room.bedCode} isThisRoom={isThisRoom} room={room} roomPrice={price} />;
    if (room.type === 'coliver') return <ColiverBox key={room.bedCode} isThisRoom={isThisRoom} room={room} />;
    return null;
  });
};

type RoomColiversInfoProps = {
  room: TRoom;
  rooms: Tenant[];
};
